@if (errorMessage) {
  <div class="sold-out-wrapper">
    <div class="sold-out-info">
      <div class="mask">
        <div class="error-img"></div>
      </div>
      <div>{{ errorMessage }}</div>
    </div>
    <button class="sold-out-cta" (click)="ctaAction()">
      {{ type === 'customization' ? 'REVIEW' : 'REMOVE' }}
    </button>
  </div>
}
